import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  campaignOf,
  canClaimPromo,
  getPromoPhase,
  isFinalDays,
  isPromoPricePreview,
  PromoCampaign,
  PromoPhase,
} from "helpers/promotionHelpers";

export interface PromoCampaignState {
  phase: PromoPhase;
  /**
   * The sale on offer right now. Null outside a sale — including the teaser,
   * which only announces Black Friday — and for anyone who can't buy.
   */
  campaign: PromoCampaign | null;
  finalDays: boolean;
  isEligible: boolean;
  /** Non-prod `?promoPrices=1`: price the campaign in regardless of the
   *  backend's offer switch. */
  isPricePreview: boolean;
}

/**
 * The seasonal promotion in force for the signed-in user right now. The phase
 * is read off the calendar in `promotionHelpers` (or `?promoPhase=` outside
 * production), so it follows the URL.
 */
export const usePromoCampaign = (): PromoCampaignState => {
  const { search } = useLocation();
  const phase = useMemo(() => getPromoPhase(search), [search]);
  const isEligible = canClaimPromo();
  return {
    phase,
    campaign: isEligible && phase !== "teaser" ? campaignOf(phase) : null,
    finalDays: isFinalDays(phase),
    isEligible,
    isPricePreview: isPromoPricePreview(search),
  };
};

export default usePromoCampaign;
